module.exports = __webpack_public_path__ + "static/media/header.f75ddc3c.svg";